import type { HTMLAttributes, ReactNode } from 'react';
import './primitives.css';

/**
 * Foundation primitive: Card（Phase D §4.3 / Phase B 凍結対象 API）
 *
 * 表面コンテナ。背景は --mg-surface、枠は --mg-border（D2 で追加した mood トークン）。
 * div の標準属性は ...rest で透過する。
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export function Card({ className, children, ...rest }: CardProps) {
  const classes = ['mg-card', className].filter(Boolean).join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
